export function defaultProjectName(prefix, sectionTitle) {
  const year = new Date().getFullYear();
  return sectionTitle ? `${prefix} – ${sectionTitle} ${year}` : `${prefix} ${year}`;
}
